import * as types from './../actionTypes';
import Resource from '../../services/PrivateAPIResource'
import {MAINTENANCE_MODE_STATUS} from '../../services/Resource'

export function triggerMaintenanceMode(status) {
    return {type: types.TRIGGER_MAINTENANCE_MODE, status};
}

export function checkMaintenanceMode() {
    return function (dispatch) {
        return fetch(Resource.prefix() + '/maintenances', {credentials: 'include'})
            .then(response => {
                if(response.status === MAINTENANCE_MODE_STATUS) {
                    return;
                }

                return dispatch(triggerMaintenanceMode(false));
            });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/common/maintenanceModeActions.js